export const LOGIN_NA = "LOGIN_NA";
export const ALREADY_REG = "ALREADY_REG";
export const REGISTER_REQUIRE = "REGISTER_REQUIRE_";
export const REGISTER_REQUIRE_EMAIL = "REGISTER_REQUIRE_EMAIL";
export const TOO_YOUNG = "TOO_YOUNG";
export const PASSWORD_SIMPLE = "PASSWORD_SIMPLE";
export const INVALID_LOGIN_LENGTH = "INVALID_LOGIN_LENGTH";
export const FIRST_NAME = "FIRST_NAME";
export const LAST_NAME = "LAST_NAME";
export const INVALID_COUNTRY = "INVALID_COUNTRY";
export const INVALID_EMAIL = "INVALID_EMAIL";
export const INVALID_BDAY = "INVALID_BDAY";
export const SHORT_PASSWORD = "SHORT_PASSWORD";
export const LONG_PASSWORD = "LONG_PASSWORD";
export const COUNTRY_BLOCKED = "COUNTRY_BLOCKED";
export const INVALID_CASINO = "INVALID_CASINO";
export const REGISTRATION_FAILED = "REGISTRATION_FAILED";
export const PHONE_REQ = "PHONE_REQ";
export const INCORRECT_PASSWORD = "INCORRECT_PASSWORD";
export const INVALID_LOGIN_CHAR = "INVALID_LOGIN_CHAR";

export const CSSFILE = "registration.css";
export const REGISTRATION_CSSFILE = "registration_brand.css";
export const MIN_GAMBLING_AGE = 15;
